module.exports = __webpack_public_path__ + "static/logo.1baf0428.png";